import React from 'react'
import styled from 'styled-components'
import Code from '../components/Code'
import IncomeExpenseGraph from '../components/Graphs/IncomeExpenseGraph'
import cashflow from '../data/uae/cashflow'
import Attribute from '../components/Attribute'
import CategoryInsightModule from '../components/CategoryInsightModule'
import incomeIcon from '../images/categories/income.png'
import travelIcon from '../images/categories/travel.png'
import diningIcon from '../images/categories/dining.png'
import retailIcon from '../images/categories/retail.png'
import entertainmentIcon from '../images/categories/entertainment.png'
import businessIcon from '../images/categories/business.png'
import eatingIcon from '../images/categories/eatingout.png'
import governmentIcon from '../images/categories/government.png'
import healthIcon from '../images/categories/health.png'
import rentIcon from '../images/categories/rent.png'
import transferIcon from '../images/categories/transfer.png'
import transportIcon from '../images/categories/transport.png'

const Container = styled.div`
  background-color: #FCFCFC;
  padding: 0 24px 24px 24px;

  p {
    margin: 0;
  }

  h2 {
    margin: 0;
    padding: 16px 0;
    font-size: 16px;
    font-weight: 600;
  }

  h3 {
    margin: 12px 0 0 0;
    padding: 16px 0;
    font-size: 16px;
    font-weight: 500;
  }
`

const Flex = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media screen and (min-width: 700px) {
      flex-direction:row;
  }
`

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 24px;
  margin-top: 24px;
`

const Insights = () => {
    const monthly_incomes = cashflow.incoming.all_transactions.raw_monthly_totals 
    const monthly_expenses = cashflow.outgoing.all_transactions.raw_monthly_totals
    
    const rentAndServices = []
    const healthAndWellBeing = []
    const income = []
    const loansAndInvestments = []
    const groceries = []
    const retail = []
    const transfers = []
    const entertainment = []
    const restaurantsDining = []
    const transport = []
    const travel = []
    const feesAndCharges = []
    const government = []
    const otherRegularExpenses = []

    // calculate mean disposable income
    const mda = []
    var medianDisposable = 0
    
    monthly_incomes.forEach((item, index) => {
            let v = item - monthly_expenses[index]
            mda.push(v)
        })
    
    mda.forEach((month) => medianDisposable = medianDisposable + month)
    medianDisposable = medianDisposable / 12

    // create arrays for each spend category
    cashflow.repeating_transactions.forEach((transaction) => {
        switch (transaction.category) {
            case 'RENT_AND_SERVICES':
                rentAndServices.push(transaction)
                break;
            case 'HEALTH_AND_WELLBEING':
                healthAndWellBeing.push(transaction)
                break;
            case 'RESTAURANTS_DINING':
                restaurantsDining.push(transaction)
                break;
            case 'GROCERIES':
                groceries.push(transaction)
                break;
            case 'LOANS_AND_INVESTMENTS':
                if (transaction.direction === 'INCOME') {
                    break;
                } else {
                    loansAndInvestments.push(transaction)
                }
                break;
            case 'RETAIL':
                retail.push(transaction)
                break;
            case 'TRANSFER':
                transfers.push(transaction)
                break;
            case 'ENTERTAINMENT':
                entertainment.push(transaction)
                break;
            case 'TRANSPORT':
                transport.push(transaction)
                break;
            case 'TRAVEL':
                travel.push(transaction)
                break;
            case 'GOVERNMENT':
                government.push(transaction)
                break;
            case 'BANK_FEES_AND_CHARGES':
                feesAndCharges.push(transaction)
                break;
            default:
                if (transaction.direction === 'INCOME') {
                    income.push(transaction)
                } else {
                    otherRegularExpenses.push(transaction)
                }
                break;
        }
    })

    return (
        <>
            <Container>
                <h2>Cashflow Analysis</h2>
                <IncomeExpenseGraph income={monthly_incomes} expense={monthly_expenses} />
                <Flex>
                    <div style={{ width: '100%'}}>
                        <Attribute title="Mean Income" value={cashflow.incoming.all_transactions.mean_per_month.last_12_months.toLocaleString()} />
                        <Attribute title="Mean Expenses" value={cashflow.outgoing.all_transactions.mean_per_month.last_12_months.toLocaleString()} />
                        <Attribute title="Mean Disposable Income" value={medianDisposable.toFixed(2)} />
                    </div>
                </Flex>
                <div style={{ height: '24px' }} />
                <h2>Regular Spend Categories</h2>
                <Grid>
                    <CategoryInsightModule icon={incomeIcon} title="Income" transactions={income} />
                    <CategoryInsightModule icon={businessIcon} title="Loan Repayments" transactions={loansAndInvestments} />
                    <CategoryInsightModule icon={rentIcon} title="Rent &amp; Services" transactions={rentAndServices} />
                    <CategoryInsightModule icon={retailIcon} title="Shopping" transactions={retail} />
                    <CategoryInsightModule icon={diningIcon} title="Groceries" transactions={groceries} />
                    <CategoryInsightModule icon={eatingIcon} title="Eating Out" transactions={restaurantsDining} />
                    <CategoryInsightModule icon={transportIcon} title="Transport" transactions={transport} />
                    <CategoryInsightModule icon={travelIcon} title="Travel" transactions={travel} />
                    <CategoryInsightModule icon={entertainmentIcon} title="Entertainment" transactions={entertainment} />
                    <CategoryInsightModule icon={healthIcon} title="Health &amp; Wellbeing" transactions={healthAndWellBeing} />
                    <CategoryInsightModule icon={transferIcon} title="Transfers" transactions={transfers} />
                    <CategoryInsightModule icon={governmentIcon} title="Government &amp; Taxes" transactions={government} />
                </Grid>
            </Container>
            <Code code={cashflow} />
        </>
    )
}

export default Insights